<template>
    <div class="cash-row" :class="{ 'cash-row--locked': locked }">
        <span class="cash-row-name">{{ name }}</span>

        <button-tooltip v-if="locked" top :tooltip="lockedHint">
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" size="13" class="cash-row-lock">mdi-lock-outline</v-icon>
            </template>
        </button-tooltip>

        <span v-if="locked" class="cash-row-amount">{{ formatMoney(amount) }}</span>
        <input v-else class="cash-row-input" type="text" inputmode="numeric" :value="display" @focus="onFocus"
            @blur="onBlur" @keyup.enter="blurInput">

        <v-menu v-if="!locked" offset-y left nudge-bottom="4" transition="slide-y-transition">
            <template v-slot:activator="{ on: menu, attrs: menuAttrs }">
                <button-tooltip top :tooltip="$t('common.options')">
                    <template v-slot:activator="{ on: tooltip, attrs }">
                        <button type="button" class="cash-row-more" v-bind="{ ...menuAttrs, ...attrs }"
                            v-on="{ ...menu, ...tooltip }">
                            <v-icon size="15">mdi-dots-horizontal</v-icon>
                        </button>
                    </template>
                </button-tooltip>
            </template>
            <v-list dense color="surface" class="py-1">
                <v-list-item @click="$emit('rename')">
                    <v-list-item-title class="cash-menu-item">{{ $t('business.rename') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('delete')">
                    <v-list-item-title class="cash-menu-item cash-menu-item--danger">
                        {{ $t('common.delete') }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <span v-else class="cash-row-more-spacer" />
    </div>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";
import { formatMoney, parseAmount } from "@/utils/Business";

export default {
    name: "CashRow",
    components: { ButtonTooltip },
    props: {
        name: {
            type: String,
            default: '',
        },
        amount: {
            type: Number,
            default: 0,
        },
        locked: {
            type: Boolean,
            default: false,
        },
        lockedHint: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            focused: false,
        }
    },
    computed: {
        display(vm = this) {
            if (vm.focused) return vm.amount || ''
            return vm.amount ? formatMoney(vm.amount) : ''
        },
    },
    methods: {
        formatMoney,
        onFocus(event) {
            const vm = this
            vm.focused = true
            vm.$nextTick(() => { event.target.value = vm.amount || '' })
        },
        onBlur(event) {
            const vm = this
            vm.focused = false
            const value = parseAmount(event.target.value)
            event.target.value = value ? formatMoney(value) : ''
            if (value !== vm.amount) vm.$emit('change', value)
        },
        blurInput(event) {
            event.target.blur()
        },
    },
}
</script>

<style scoped>
.cash-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 14px;
    border-top: 1px solid var(--v-outline-base);
}

.cash-row-name {
    flex: 1 1 auto;
    min-width: 0;
    font-size: var(--fs-caption);
    color: var(--v-txtSecondary-base);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cash-row-lock {
    color: var(--v-txtMuted-base) !important;
    flex-shrink: 0;
}

.cash-row-amount {
    width: 108px;
    flex-shrink: 0;
    text-align: right;
    font-size: var(--fs-caption);
    font-weight: 700;
    color: var(--v-txtMuted-base);
}

.cash-row-input {
    width: 108px;
    flex-shrink: 0;
    height: 28px;
    padding: 0 9px;
    border-radius: 7px;
    background: var(--v-field-base);
    border: 1px solid transparent;
    text-align: right;
    font-size: var(--fs-caption);
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    outline: none;
    transition: border-color 0.15s;
}

.cash-row-input:hover {
    border-color: var(--v-outline-base);
}

.cash-row-input:focus {
    border-color: var(--v-accent-base);
}

.cash-row-more {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 6px;
    color: var(--v-txtMuted-base);
}

.cash-row-more:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
}

.cash-row-more-spacer {
    width: 24px;
    flex-shrink: 0;
}

.cash-menu-item {
    font-size: var(--fs-caption);
    font-weight: 600;
    color: var(--v-txtSecondary-base);
}

.cash-menu-item--danger {
    color: var(--v-error-base);
}
</style>
